module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.62853729.svg";